import { useEffect, useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useDispatch } from '../store';
import services from 'services';

const LocationChangeReset = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  const params = useMemo(() => {
    const excludeParams = ['page', 'limit', 'search', 'filters'];
    return Array.from(searchParams.entries())
      .filter(([k]) => !excludeParams.some((p) => k.startsWith(p)))
      .reduce((str, [k, v]) => str + `${k}:${v};`, '');
  }, [searchParams]);

  useEffect(() => {
    services.forEach((service) => dispatch(service.util.resetApiState()));
  }, [location.pathname, params, dispatch]);

  return null;
};

export default LocationChangeReset;
